import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { CustomBreadcrumb } from "../../components";
import { NOTIFICATION_CONSTANTS } from "../../config/constants";
import { NotificationStyled } from "./styled";
import NotificationCreate from "./NotificationCreate";
import NotificationHistory from "./NotificationHistory";
import { DISPLAY_FLEX } from "../../config/styles";

const Notifications = () => {
  const [activeTab, setActiveTab] = React.useState("Create");
  const [showTabs, setShowTabs] = React.useState(true);
  const onHideTabs = () => setShowTabs(false);
  const onShowTabs = () => setShowTabs(true);

  return (
    <CustomBreadcrumb
      header={NOTIFICATION_CONSTANTS.HEADER}
      currentPage={NOTIFICATION_CONSTANTS.CURRENT_TAB}
    >
      <NotificationStyled>
        <Tabs
          style={{ display: DISPLAY_FLEX }}
          defaultActiveKey={activeTab}
          onSelect={(event) => setActiveTab(event)}
        >
          <Tab
            className="disabled"
            unmountOnExit
            eventKey="Create"
            title="Create"
            mountOnEnter={true}
          >
            <NotificationCreate />
          </Tab>
          <Tab
            className="disabled"
            unmountOnExit
            eventKey="History"
            title="History"
            mountOnEnter={true}
          >
            <NotificationHistory
              onHideTabs={onHideTabs}
              onShowTabs={onShowTabs}
            />
          </Tab>
        </Tabs>
      </NotificationStyled>
    </CustomBreadcrumb>
  );
};

export default Notifications;
